import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop,Watch } from 'vue-property-decorator';

@Component({})
class EdEditableLabel extends Vue {

  /* Props */
  @Prop({}) readonly value: any;
  @Prop({}) readonly initialStateInput: boolean;
  @Prop({}) readonly placeholder: string;
  @Prop({}) readonly disabled: boolean;
  @Prop({}) readonly unavailableNamesList: Array<string>;
  @Prop({}) readonly maxLength: number;

  /* Data */
  public newValue: string = '';
  public editionMode: boolean = false;
  public defaultSize: string = '1.15rem';

  /* Computed */
  get disabledStyle(){
    if(this.disabled)
      return {  'background-color':'var(--ed-color-gray-lighter)',
                'border-color':'var(--ed-color-gray-lighter)' }
  }

  get isError(){
    if(this.newValue.trim().length == 0)
      return true;
    else if(this.isNewValueUnavailable)
      return true;
    else
      return false;
  }

  get isNewValueUnavailable(){
    let unavailableName = false;
    this.unavailableNamesList.forEach(str => {
      if(this.newValue.trim() == str.trim() && this.newValue.trim() != this.value.trim()){
        unavailableName = true;
      }
    });
    return unavailableName;
  }

  /* Methods */
  toggleEdition(newEditionMode:boolean){
    if(this.disabled)
      return;
    if(!newEditionMode){
      if(this.newValue.trim().length == 0){
        if(this.value == undefined || this.value.trim().length == 0  ){
          this.$emit('delete');
          return;
        }
        this.newValue = this.value;
      }
      else if(this.unavailableNamesList && this.unavailableNamesList.length > 1){
        if(this.isNewValueUnavailable){
          this.$emit('unavailable');
          return;
        }
      }
    }
    this.editionMode = undefined;
    this.$nextTick(()=>{
      this.editionMode = newEditionMode;
    })
    
    if(!newEditionMode)
      this.saveEdit();
    else{
      this.focusInput();
    }
  }

  saveEdit() {
    this.$emit('input', this.newValue);
  }

  labelClicked(){
    this.$emit('labelClicked');
  }

  focusInput(){
    this.$nextTick(()=>{
      this.$nextTick(()=>{
        (this.$refs.input as any).focus();
      });
    });
  }

  /* Hooks */
  created() {
    this.newValue = this.value;
  }

  mounted(){
    if(this.initialStateInput){
      this.editionMode = true;
      if(!this.disabled){
        this.focusInput();
      }
    }
  }

  /* Watch */
  @Watch('value')
  valueChanged(value:string){
    this.newValue = value;
    if(this.initialStateInput){
      this.editionMode = true;
      if(!this.disabled){
        this.focusInput();
      }
    }
  }
}

export default Vue.component('ed-editable-label', EdEditableLabel);